<template>
  <div id="picture-card-wrap">
    <div class="picture-card" :class="[isFeedback ? 'feedback-picture-card' : '']">
      <div class="scroll-wrap">
        <div class="card-title" v-if="!isFeedback">本地上传</div>
        <div class="card-count" v-if="!isFeedback">共{{ getPictureCount }}张</div>
        <div class="item-title" v-else>
          <div class="card-title">本地上传</div>
          <div class="card-count">共{{ getPictureCount }}张</div>
        </div>
        <div class="item-content">
          <div class="upload-item" :class="[isFeedback ? 'feedback-unload-item' : '']" v-for="(item, index) in fileList" :key="index">
            <div class="item-container" @click="handlerPreview(item)">
              <img ref="fileImg" :src="item.src">
              <i v-if="item.sourceUrl" class="icon-player-pause"></i>
            </div>
            <i class="delete-table" @click="deleteFile(index)"></i>
          </div>
          <div class="upload-button" :class="[isFeedback ? 'feedback-upload-button' : '']" @click="addPicture" v-show="!isMaxPicture">添加图片</div>
        </div>
      </div>
    </div>

    <form name="form" enctype="multipart/form-data" style="display: none">
      <input type="file" name="file" v-on:change="inputChange" multiple="multiple" ref="fileInput">
    </form>
  </div>
</template>

<script>
import {mapMutations} from 'vuex'
export default {
  name: 'pictureCard',
  props: {
    fileList: {
      type: Array,
      default () {
        return []
      }
    },
    isFeedback: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
    }
  },
  computed: {
    getPictureCount () {
      return this.fileList.length
    },
    isMaxPicture () {
      return this.fileList.length >= 12
    },
    imgList () {
      let list = []
      if (this.getPictureCount) {
        this.fileList.forEach(item => {
          list.push(item.src)
        })
      }
      return list
    }
  },
  methods: {
    ...mapMutations([
      'setImgForPreview',
      'SET_VIDEO_DIALOG'
    ]),
    handlerPreview (item) {
      if (item.sourceUrl) {
        this.handlerOpenPlayer(item.sourceUrl)
      } else {
        this.handlerPreviewImg(item.src);
      }
    },
    handlerOpenPlayer (src) {
      this.SET_VIDEO_DIALOG({videoId: src.split('.')[0]});
    },
    handlerPreviewImg (src) {
      this.setImgForPreview({
        imgSrcNeedToPreview: this.imgList,
        currImgNeedToPreview: src,
        needShowImgPreviewCommon: true
      })
    },
    addPicture () {
      this.$refs.fileInput.click()
    },
    deleteFile (index) {
      this.$emit('deleteFile', index)
    },
    inputChange (event) {
      this.$emit('inputChange', event)
    }
  }
}
</script>

<style scoped>
  .icon-player-pause {
    width: 15px;
    height: 15px;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    margin: auto;
    position: absolute;
    background: url("~@/icons/icon-player-pause.png") no-repeat;
    background-size: 15px 15px;
    background-position: center;
  }

  ::-webkit-scrollbar {
    width: 2px;
  }
  ::-webkit-scrollbar-thumb {
    border-radius: 2px;
    background-color: #ccc;
  }
  ul, li {
    margin: 0;
    padding: 0;
  }
  #picture-card-wrap {
    display: inline-block;
    /*max-height: 224px;*/
  }
  .picture-card {
    box-sizing: border-box;
    position: relative;
    width: 329px;
    min-height: 160px;
    border: 1px solid #4a90e2;
    border-radius: 2px;
    box-shadow: 0 2px 4px 0 rgba(73, 143, 226, 58);
    background: #fff;
  }
  .feedback-picture-card {
    width: 300px;
  }
  .scroll-wrap {
    box-sizing: border-box;
    width: 100%;
    min-height: 160px;
    padding: 27px 0 14px 16px;
    overflow-x: hidden;
    overflow-y: hidden;
  }
  .scroll-wrap:hover {
    overflow-y: scroll
  }

  .picture-card:before {
    position: absolute;
    content: "";
    width: 0;
    height: 0;
    padding: 0;
    top: -16px;
    left: 41px;
    border-bottom: 8px solid #fff;
    border-top: 8px solid transparent;
    border-left: 8px solid transparent;
    border-right: 8px solid transparent;
    z-index: 11;
  }
  .picture-card:after {
    position: absolute;
    content: "";
    width: 0;
    height: 0;
    padding: 0;
    top: -18px;
    left: 40px;
    border-bottom: 9px solid #4a90e2;
    border-top: 9px solid transparent;
    border-left: 9px solid transparent;
    border-right: 9px solid transparent;
    z-index: 10;
  }
  .item-title {
    display: flex;
  }
  .item-title .card-count {
    margin-top: 0;
    margin-left: 8px;
  }
  .card-title {
    font-size: 12px;
    color: #333;
  }
  .card-count {
    margin-top: 9px;
    font-size: 12px;
    color: #999;

  }

  .upload-list {
  }
  .upload-item {
    display: inline-block;
    vertical-align: top;
    position: relative;
    width: 58px;
    height: 58px;
    margin-right: 15px;
    margin-top: 19px;
    background-color: #fff;
    border: 1px solid #a8a8a8;
  }

  .item-container {
    display: inline-block;
    cursor: pointer;
  }

  .upload-item img {
    position: relative;
    width: 58px;
    height: 58px;
  }
  .feedback-unload-item {
    width: 50px;
    height: 50px;
  }
  .feedback-unload-item img {
    width: 50px;
    height: 50px;
  }
  .upload-button {
    box-sizing: border-box;
    vertical-align: top;
    display: inline-block;
    width: 58px;
    height: 58px;
    padding: 8px 11px;
    margin-top: 19px;
    margin-right: 15px;
    border: 1px dashed #a8a8a8;
    border-radius: 4px;
    font-size: 15px;
    color: #a8a8a8;
    text-align: center;
    cursor: pointer;
  }
  .feedback-upload-button {
    width: 50px;
    height: 50px;
    padding: 8px 9px;
    font-size: 13px;
  }
  .item-content {}
  .delete-table {
    position: absolute;
    top: -7px;
    right: -7px;
    width: 15px;
    height: 15px;
    background: url("../../icons/image/delete.png");
    background-size: 15px 15px;
    cursor: pointer;
  }
  .item-img {
    width: 58px;
    height: 58px;
    margin: 0;
    padding: 0;
  }
</style>



// WEBPACK FOOTER //
// src/components/picture-card/picture-card.vue